export default {
    name: "accordion-item",
    props: {},
    inject: ["Accordion"],
    data() {
        return {
            index: null,
        };
    },
    computed: {
        visible() {
            return this.index == this.Accordion.active;
        },
    },
    methods: {
        open() {
            if (this.visible) {
                this.Accordion.active = null;
            } else {
                this.Accordion.active = this.index;
            }
        },
        start(el) {
            el.style.height = el.scrollHeight + "px";
        },
        end(el) {
            el.style.height = "";
        },
    },
    created() {
        this.index = this.Accordion.count++;
    },
};
